module.exports = __webpack_public_path__ + "img/pwa-installed-award.fa2d8d01.png";